import React from "react";
import {Provider} from "react-redux";
import searchResultStore from "./store/rootStore";
import SearchResultApp from "./SearchResultApp";
import ErrorBoundary from "./ErrorBoundary";

const SearchResultBase = () => {
    return (
        <Provider store={searchResultStore}>
            <ErrorBoundary>
                <SearchResultApp/>
            </ErrorBoundary>
        </Provider>
    )
}

export default SearchResultBase;